import z from 'zod'

export const CoercedNumberArraySchema = z
  .array(z.string())
  .transform((val) => val.map((item) => Number(item)).filter((item) => !isNaN(item)))
